import React from "react";
import Badge from "react-bootstrap/Badge";

const ConstantsTable = ({ data, handleChange, handleUpdate, total }) => {
  return (
    <table className="table table-sm table-hover">
      <caption style={{ captionSide: "top", paddingBottom: 0 }}>
        {total} Global Constants
      </caption>
      <thead>
        <tr>
          <th>Parameter</th>
          <th>Heading</th>
          <th>In Use</th>
          <th>Min</th>
          <th>Max</th>
          <th>Bu Constant</th>
          <th>Ca Constant</th>
          <th>Ne Constant</th>
          <th>Wi Constant</th>
          <th />
        </tr>
      </thead>
      <tbody>
        {data.map((parameter, i) => (
          <tr
            key={parameter.CODE}
            className={parameter.IN_USE_FLAG ? "" : "bg-light"}
          >
            <td className="text-nowrap">{parameter.CODE}</td>
            <td>{parameter.NAME}</td>
            <td>
              {parameter.IN_USE_FLAG ? (
                <Badge variant="success">True</Badge>
              ) : (
                <Badge variant="warning">False</Badge>
              )}
            </td>
            <td>{parameter.MIN_LIMIT}</td>
            <td>{parameter.MAX_LIMIT}</td>
            <td>
              <input
                name={parameter.CODE}
                className="number-input-sm"
                type="text"
                value={parameter.BU_CONSTANT ? parameter.BU_CONSTANT : ""}
                onChange={(e) => handleChange(e, i, "BU_CONSTANT")}
              />
            </td>
            <td>
              <input
                name={parameter.CODE}
                className="number-input-sm"
                type="text"
                value={parameter.CA_CONSTANT ? parameter.CA_CONSTANT : ""}
                onChange={(e) => handleChange(e, i, "CA_CONSTANT")}
              />
            </td>
            <td>
              <input
                name={parameter.CODE}
                className="number-input-sm"
                type="text"
                value={parameter.NE_CONSTANT ? parameter.NE_CONSTANT : ""}
                onChange={(e) => handleChange(e, i, "NE_CONSTANT")}
              />
            </td>
            <td>
              <input
                name={parameter.CODE}
                className="number-input-sm"
                type="text"
                value={parameter.WI_CONSTANT ? parameter.WI_CONSTANT : ""}
                onChange={(e) => handleChange(e, i, "WI_CONSTANT")}
              />
            </td>
            <td className="text-nowrap">
              {parameter.IN_USE_FLAG && (
                <button
                  className="btn btn-primary btn-sm"
                  onClick={() => handleUpdate(parameter)}
                >
                  Update
                </button>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default ConstantsTable;
